import styleConfig from './styleConfig';
import robotConfig from './robotConfig';
import channelConfig from './channelConfig';
import { configureStore } from '@reduxjs/toolkit';
import getAnonymousToken from './getAnonymousToken';

const store = configureStore({
  reducer: {
    styleConfig,
    robotConfig,
    channelConfig,
    getAnonymousToken
  }
});

export default store;
